export default __webpack_public_path__ + "static/media/e.a110d809.svg";